const cooper = {
  fontFamily: "'Cooper', serif",
};

const lausanne = {
    fontFamily: `'Lausanne', sans-serif`,
}

export const typography = {
  display: {
    xxl: {
        ...cooper,
        fontSize: "6rem", //96px
        lineHeight: "7rem", //112px
    },
    xl: {
        ...cooper,
        fontSize: "3.25rem", //52px
        lineHeight: "4rem", //64px
    },
    lg: {
        ...cooper,
        fontSize: "2.75rem", //44px
        lineHeight: "3rem", //48px
    },
    md: {
        ...cooper,
        fontSize: "2.25rem", //36px
        lineHeight: "2.75rem", //44px
    },
    sm: {
        ...cooper,
        fontSize: "2rem", //32px
        lineHeight: "2.5rem", //40px
    },
    xs: {
        ...cooper,
        fontSize: "1.75rem", //28px
        lineHeight: "2rem", //32px
    },
    xxs: {
        ...cooper,
        fontSize: "1.625rem", //26px
        lineHeight: "2rem", //32px
    },
    x3s: {
        ...cooper,
        fontSize: "1.375rem", //22px
        lineHeight: "1.5rem", //24px
    },
    x4s: {
        ...cooper,
        fontSize: "1.25rem", //20px
        lineHeight: "1.5rem", //24px
    },
  },
  heading: {
    xxl: {
        ...lausanne,
        fontSize: "2.5rem", //40px
        lineHeight: "3.25rem", //52px
    },
    xl: {
        ...lausanne,
        fontSize: "2.25rem", //36px
        lineHeight: "2.75rem", //44px
    },
    lg: {
        ...lausanne,
        fontSize: "2rem", //32px
        lineHeight: "2.5rem", //40px
    },
    md: {
        ...lausanne,
        fontSize: "1.75rem", //28px
        lineHeight: "2.25rem", //36px
    },
    sm: {
        ...lausanne,
        fontSize: "1.5rem", //24px
        lineHeight: "2rem", //32px
    },
    xs: {
        ...lausanne,
        fontSize: "1.25rem", //20px
        lineHeight: "1.75rem", //28px
    },
  },
  label: {
    lg: {
        ...lausanne,
        fontSize: "1.125rem", //18px
        lineHeight: "1.5rem", //24px
    },
    md:{
        ...lausanne,
        fontSize: "1rem", //16px
        lineHeight: "1.25rem", //20px
    },
    sm: {
        ...lausanne,
        fontSize: "0.875rem", //14px
        lineHeight: "1rem", //16px
    },
    xs: {
        ...lausanne,
        fontSize: "0.75rem", //12px
        lineHeight: "1rem", //16px
    },
  },
  paragraph: {
    lg: {
        ...lausanne,
        fontSize: "1.125rem", //18px
        lineHeight: "2rem", //32px
    },
    md:{
        ...lausanne,
        fontSize: "1rem", //16px
        lineHeight: "2rem", //32px
    },
    sm: {
        ...lausanne,
        fontSize: "0.875rem", //14px
        lineHeight: "1.25rem", //20px
    },
    xs: {
        ...lausanne,
        fontSize: "0.75rem", //12px
        lineHeight: "1rem", //16px
    },
  },
};